import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { menuSections, siteConfig } from '../siteConfig';
import { navigate } from '../router';
import { LanguageSwitcher } from './LanguageSwitcher';
import './Header.css';

type Props = {
  /** Until the pexeso game is finished, the RSVP link is hidden from the
      nav so guests don't bypass the intro by clicking through to the form. */
  gameComplete: boolean;
};

export function Header({ gameComplete }: Props) {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const sections = menuSections().filter((id) => id !== 'rsvp' || gameComplete);
  const shopEnabled = siteConfig.pages.shop.enabled;
  const hasMenu = sections.length > 0 || shopEnabled;

  return (
    <header className={`site-header ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="site-header__inner">
        <a href="#" className="site-header__mark" aria-label={siteConfig.event.coupleShort}>
          <img src="/assets/nj-mark.png" alt="" />
        </a>

        {hasMenu && (
          <nav className="site-header__nav">
            <ul>
              {sections.map((id) => (
                <li key={id}>
                  <a href={`#${siteConfig.sections[id].anchor}`}>
                    {siteConfig.sections[id].anchor}
                  </a>
                </li>
              ))}
              {shopEnabled && (
                <li key="shop">
                  <a
                    href={siteConfig.pages.shop.path}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(siteConfig.pages.shop.path);
                    }}
                  >
                    {t('nav.shop')}
                  </a>
                </li>
              )}
            </ul>
          </nav>
        )}

        {shopEnabled && (
          <a
            className="site-header__shop"
            href={siteConfig.pages.shop.path}
            onClick={(e) => {
              e.preventDefault();
              navigate(siteConfig.pages.shop.path);
            }}
          >
            {t('nav.shop')}
          </a>
        )}

        <LanguageSwitcher />
      </div>
    </header>
  );
}
